/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import { Modal, Button } from "react-bootstrap";
import { useEffect, useRef, useState } from "react";
import { useAuth } from "../../../auth";
import clsx from "clsx";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { ingredientSchema } from "../core/Schema";
import { addingredients, findDuplicateIngredient } from "../../dish/core/_requests";
import { Ingredient, initialValues } from "../core/_models";
import CloseButton from "../../../component/core/Buttons";
interface ModalProps {
  show: boolean;
  onHide: () => void;
}

const AddIngredient: React.FC<ModalProps> = ({ show, onHide }) => {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const [data, setData] = useState<Ingredient>(initialValues);
  const [duplicate, setDuplicate] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const inputs = useRef<Array<HTMLInputElement | HTMLSelectElement | null>>([]);
  const formRef = useRef<HTMLFormElement>(null);


  const formik = useFormik<Ingredient>({
    initialValues,
    enableReinitialize: true,
    validationSchema: ingredientSchema,
    onSubmit: (values, actions) => {
      actions.resetForm({ values: initialValues });
      setLoading(true);
      setTimeout(() => {
        values.chefId = currentUser?.uuid;
        values.createdBy = currentUser?.chefId;
        const updatedData = Object.assign(data, values);
                setLoading(true);
        addingredients(updatedData)
          .then((res) => {
                        if (res?.status === true) {
              toast.success(res?.message, { autoClose: 5000 });
              setData(initialValues);
              navigate("/ingredients/list");
              onHide();
              setLoading(false);
            } else {
              toast.error(res?.message, { autoClose: 5000 });
              setLoading(false);
            }
            setData(initialValues);
          })
          .catch((err) => {
            setLoading(false);
            setErrorMessage("Something Went Wrong");
          });
      }, 1000);
    },
  });

  useEffect(() => {
    findDuplicateIngredient(formik.values.name).then((response) => {
      if (response?.isDuplicate === true) {
        setDuplicate(`Ingredient name ${response?.ingredients} already exists`);
      } else {
        setDuplicate("");
      }
    });
  }, [formik.values.name]);

  useEffect(() => {
    const emptyValues: Ingredient = {
      primaryId: "",
      chefId: "",
      name: "",
      createdBy: "",
      updatedBy: "",
    };
    formik.setValues(emptyValues);
      }, []);

      
  return (
    <>
      <Modal show={show} onHide={onHide} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add Ingredient</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form
            ref={formRef}
            onSubmit={formik.handleSubmit}
            noValidate
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
              }
            }}
          >
            <div className="col-12 mb-3">
              <label htmlFor="" className="form-label require">
                Ingredient
              </label>
              <input
                type="text"
                className={clsx(
                  "form-control",
                  {
                    "is-invalid": formik.touched.name && formik.errors.name,
                  },
                  {
                    "is-valid": formik.touched.name && !formik.errors.name,
                  }
                )}
                placeholder="Enter Your Ingredient"
                ref={(el) => {
                  inputs.current[0] = el;
                }}
                {...formik.getFieldProps("name")}
              />
              {formik.touched.name && formik.errors.name && (
                <div className="fv-plugins-message-container">
                  <span role="alert">{formik.errors.name}</span>
                </div>
              )}
              <span style={{ color: "red" }}>{duplicate ? duplicate : ""}</span>
            </div>
               <CloseButton
                  onClose={onHide}
                    onSubmit={formik.handleSubmit}
                  loading={loading}
                   disabled={formik.isSubmitting || !formik.isValid }
             />
          </form>
        </Modal.Body>
      </Modal>
      <ToastContainer /> {/* To render toast notifications */}
    </>
  );
};

export default AddIngredient;
